<template>
  <BaseNode
    :node="node"
    :editor-errors="editorErrors"
    color="#4472c4"
  />
</template>

<script>
import nodeMixin from './nodeMixin'

export default {
  mixins: [nodeMixin]
}
</script>
